import { MouseEvent, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const useAccessibleLinks = () => {
  const history = useHistory();

  // We don't have native hash navigation because we use routing. This will override that nav and scroll & focus instead. Mainly used in skip links for accessibility.
  useEffect(() => {
    function handleLinkClick(event: MouseEvent<HTMLAnchorElement, MouseEvent>) {
      const target = (event.target as HTMLElement).closest('a[href]');

      if (target) {
        const href = target.getAttribute('href');

        if (href?.startsWith('#')) {
          event.preventDefault();

          const id = href.substring(1);
          const focusElement = document.getElementById(id);

          focusElement?.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
          focusElement?.focus();
        }
      }
    }

    document.addEventListener('click', handleLinkClick as any);
    return () => {
      document.removeEventListener('click', handleLinkClick as any);
    };
  }, [history]);
};

export default useAccessibleLinks;
